import React from "react";

/**
 * iter70b · Small plan chip used across the Command Center so operators
 * can spot a tenant's subscription tier at a glance. Colour signals the
 * "size" of the plan — brass for Founding (grandfathered), green for
 * paid tiers, muted grey for the default entry-level plan.
 */
const PLAN_STYLES = {
  // Club plans
  "Club Founding":     { bg: "bg-[#FBF6E8]", text: "text-[#8a6f33]", ring: "border-[#B59A5A]" },
  "Club Essentials":   { bg: "bg-[#F0EDE0]", text: "text-[#4A4A4A]", ring: "border-[#C8C3AA]" },
  "Club Professional": { bg: "bg-[#E9F0EB]", text: "text-[#1A422D]", ring: "border-[#1A422D]" },
  "Club Signature":    { bg: "bg-[#0f1a14]", text: "text-[#D9C68A]", ring: "border-[#D9C68A]" },
  // Vendor plans
  "Vendor Founding":     { bg: "bg-[#FBF6E8]", text: "text-[#8a6f33]", ring: "border-[#B59A5A]" },
  "Vendor Access":       { bg: "bg-[#F0EDE0]", text: "text-[#4A4A4A]", ring: "border-[#C8C3AA]" },
  "Vendor Professional": { bg: "bg-[#E9F0EB]", text: "text-[#1A422D]", ring: "border-[#1A422D]" },
  "Vendor Enterprise":   { bg: "bg-[#0f1a14]", text: "text-[#D9C68A]", ring: "border-[#D9C68A]" },
  "Vendor Featured":     { bg: "bg-[#1A422D]", text: "text-[#F9F8F4]", ring: "border-[#1A422D]" },
};

export default function PlanBadge({ plan, size = "sm", className = "" }) {
  if (!plan) return null;
  const style = PLAN_STYLES[plan] || {
    bg: "bg-[#F3F1E9]",
    text: "text-[#4A4A4A]",
    ring: "border-[#E5E3D8]",
  };
  // Compact ("Founding", "Professional") label — drop the tenant prefix.
  const short = plan.replace(/^Club\s+|^Vendor\s+/, "");
  const pad = size === "xs" ? "px-1.5 py-0.5 text-[9px]" : "px-2 py-0.5 text-[10px]";
  return (
    <span
      data-testid={`plan-badge-${plan.toLowerCase().replace(/\s+/g, "-")}`}
      className={`inline-flex items-center gap-1 uppercase tracking-[0.18em] border ${style.ring} ${style.bg} ${style.text} ${pad} ${className}`}
      title={plan}
    >
      {short}
    </span>
  );
}
